/*
 * Copyright (c) 2008-present Sonatype, Inc.
 *
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/pro/attributions
 * Sonatype and Sonatype Nexus are trademarks of Sonatype, Inc. Apache Maven is a trademark of the Apache Foundation.
 * M2Eclipse is a trademark of the Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import React from 'react';
import {useMachine, useService} from '@xstate/react';
import {faLock} from '@fortawesome/free-solid-svg-icons';

import {Button, ContentBody, NxFontAwesomeIcon, NxLoadWrapper, Section, SectionFooter} from 'nexus-ui-plugin';
import UIStrings from '../../../../constants/UIStrings';
import UserTokenMachine from './UserTokenMachine';
import UserTokenDetails from './UserTokenDetails';
import './UserToken.scss';

export default function UserToken() {
  const service = useMachine(UserTokenMachine, {devTools: true})[2];

  return <UserTokenForm service={service}/>;
}

export function UserTokenForm({service}) {
  const [current, send] = useService(service);

  const context = current.context;
  const isLoading = !(current.matches('idle') || current.matches('showToken'));

  function onAccessTokenClick() {
    send('ACCESS');
  }

  function onResetTokenClick() {
    send('RESET');
  }

  function onCloseClick() {
    send('HIDE');
  }

  return <ContentBody className='nxrm-usertoken-current'>
    {current.matches('showToken') && <UserTokenDetails userToken={context.token} onCloseClick={onCloseClick}/>}
    <Section>
      <NxLoadWrapper loading={isLoading}>
        <p>{UIStrings.USER_TOKEN.LABELS.ACCESS_NOTE}</p>
        <p>{UIStrings.USER_TOKEN.LABELS.RESET_NOTE}</p>
        <SectionFooter>
          <Button variant='primary' onClick={onAccessTokenClick}>
            <NxFontAwesomeIcon icon={faLock}/>
            <span>{UIStrings.USER_TOKEN.BUTTONS.ACCESS}</span>
          </Button>
          <Button onClick={onResetTokenClick}>
            <NxFontAwesomeIcon icon={faLock}/>
            <span>{UIStrings.USER_TOKEN.BUTTONS.RESET}</span>
          </Button>
        </SectionFooter>
      </NxLoadWrapper>
    </Section>
  </ContentBody>;
}
